<template>
  <section class="project-summary" aria-labelledby="project-details-heading">
    <p v-if="userStore.isLoggedIn" class="project-summary__login">Currently Logged in as: {{ userStore.email }}</p>
    <h2 id="project-details-heading">PROJECT DETAILS</h2>
    <label for="new-studio-design-name">Name <span aria-hidden="true">?</span></label>
    <input id="new-studio-design-name" v-model="projectStore.designName" type="text" placeholder="New Design">
    <dl>
      <div><dt>Design ID:</dt><dd>{{ projectStore.designId || '—' }}</dd></div>
      <div><dt>Dimensions:</dt><dd>{{ gridStore.designSize }}</dd></div>
      <div><dt>Area:</dt><dd>{{ gridStore.designArea }}</dd></div>
    </dl>
    <div class="project-summary__actions">
      <button
        v-if="userStore.isAdmin"
        type="button"
        class="project-summary__admin-cart"
        :disabled="!actions.canAddToCart.value"
        @click="actions.createProductAndAddToCart"
      >
        Create Product &amp; Add to Cart
      </button>
      <button type="button" :disabled="!actions.hasShapes.value" @click="actions.viewTiles">
        View Tiles · {{ formattedPrice }}
      </button>
      <button type="button" :disabled="!actions.canAddToCart.value" @click="actions.addToCart">Add to Cart</button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { SweetAlertIcon } from '~/types/sweetalert'
import { createProjectNameGuard } from './logic'

const { $toast } = useNuxtApp()
const gridStore = useGridStore()
const projectStore = useProjectStore()
const userStore = useUserStore()
const actions = useNewStudioActions()
const price = computed(() => gridStore.getTilesList().reduce((total, tile) => total + tile.price * (tile.quantity || 0), 0))
const formattedPrice = computed(() => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price.value))
const nameGuard = createProjectNameGuard(projectStore.designName, (text) => {
  $toast.fire({ icon: SweetAlertIcon.INFO, text })
})
watch(() => projectStore.designName, (name) => {
  const accepted = nameGuard.accept(name)
  if (accepted !== name) projectStore.designName = accepted
})
</script>

<style scoped>
.project-summary { color: #92918d; font-size: 12px; }
.project-summary__login { margin: 0 0 2px; font-size: 11px; }
h2 { margin: 0 0 13px; color: #95948f; font-size: 12px; font-weight: 800; letter-spacing: .08em; }
label { display: block; margin-bottom: 5px; color: #73726e; font-weight: 600; }
label span { display: inline-grid; width: 13px; height: 13px; place-items: center; border-radius: 50%; background: #e9e8e5; font-size: 9px; }
input { width: 100%; height: 36px; padding: 0 12px; border: 1px solid #deddd9; color: #3c3c39; font: inherit; }
dl { display: grid; gap: 7px; margin: 12px 0 18px; }
dl div { display: flex; gap: 4px; }
dt { font-weight: 400; }
dd { margin: 0; color: #363633; font-weight: 600; }
.project-summary__actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.project-summary__actions button { min-height: 41px; border: 1px solid #dfdeda; background: #fff; color: #30312e; font: inherit; font-weight: 700; cursor: pointer; }
.project-summary__actions button.project-summary__admin-cart { grid-column: 1 / -1; border-color: #313558; background: #313558; color: #fff; box-shadow: 0 4px 8px rgb(49 53 88 / 24%); }
.project-summary__actions button.project-summary__admin-cart:disabled { opacity: 0.5; cursor: not-allowed; }
.project-summary__actions button:last-child { border-color: #313558; background: #313558; color: #fff; box-shadow: 0 4px 8px rgb(49 53 88 / 24%); }
.project-summary__actions button:disabled { cursor: not-allowed; }
</style>
